import SPageHeader from '/src/common/components/s-page-header';
import SBtn from '/src/common/components/s-btn/s-btn';
import sDeleteConfirmation from '/src/common/components/s-delete-confirmation';
import sYesNo from '/src/common/components/s-yes-no';
import SDate from '/src/common/components/s-date';

export default defineNuxtPlugin({
  async setup(nuxtApp) {
    nuxtApp.vueApp.component('s-page-header', SPageHeader);
    nuxtApp.vueApp.component('s-btn', SBtn);
    nuxtApp.vueApp.component('s-delete-confirmation', sDeleteConfirmation);
    nuxtApp.vueApp.component('s-yes-no', sYesNo);
    nuxtApp.vueApp.component('s-date', SDate);
  }
});
